import { render } from "./reduction.vue?vue&type=template&id=79e13b03&scoped=true"
import script from "./reduction.vue?vue&type=script&lang=ts"
export * from "./reduction.vue?vue&type=script&lang=ts"

import "./reduction.vue?vue&type=style&index=0&id=79e13b03&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-79e13b03"

export default script